import { u as useChakraTheme, B as Body, T as TileCheckbox } from './Provider-4d334175.esm.js';
export { b as Badge, d as BlueprintProvider, B as Body, e as Checkbox, s as Code, C as Collapse, D as Drawer, f as Field, l as FilterMenu, F as Fonts, H as Heading, I as Image, L as LoadingOverlay, p as Menu, q as MenuButton, r as MenuItemOption, M as Message, m as Modal, P as Panel, n as Popover, g as Select, S as Slider, h as StepperInput, k as TabHeading, c as Tag, i as TextInput, T as TileCheckbox, j as TileRadio, a as Toggle, o as Tooltip, u as useChakraTheme, t as useReducedMotionVariants, v as useTheme, w as useTimeoutFlag } from './Provider-4d334175.esm.js';
import { Global, css } from '@emotion/react';
import { normalize } from 'polished';
import { useState, useEffect, useCallback } from 'react';
import invariant from 'tiny-invariant';
import _omit from 'ramda/src/omit';
import _pick from 'ramda/src/pick';
import '@chakra-ui/system';
import 'ramda/src/has';
import { createStandaloneToast as createStandaloneToast$1, useToast as useToast$1, Stack, forwardRef, HStack, extendTheme } from '@chakra-ui/react';
export { AspectRatio, Center, CheckboxGroup, Container, Divider, Grid, HStack, List, ListIcon, ListItem, MenuCommand, MenuDivider, MenuGroup, MenuIcon, MenuItem, MenuOptionGroup, OrderedList, Radio, RadioGroup, SimpleGrid, Spacer, Stack, Tab, TabList, TabPanel, TabPanels, Table, Tabs, Tbody, Td, Textarea, Tfoot, Th, Thead, Tr, UnorderedList, VStack, Wrap } from '@chakra-ui/react';
import 'tiny-warning';
import { _ as _objectSpread2, A as Alert, a as _objectWithoutProperties, b as _slicedToArray, c as componentMessage, w as withTestId, B as BoxWithDeprecationWarning } from './Spinner-a063c450.esm.js';
export { A as Alert, d as AwesomeIcon, B as Box, e as Button, I as Icon, f as IconButton, L as Link, g as Loader, S as Spinner, t as defaultTheme, u as useIsMotionReduced } from './Spinner-a063c450.esm.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import 'ramda/src/fromPairs';
import 'ramda/src/toPairs';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { theme } from '@hover/chakra-theme';
export { theme as chakraTheme } from '@hover/chakra-theme';
import 'framer-motion';
import '@hover/chakra-theme/foundation';
import '@hover/chakra-theme/components';
import '@hover/utilities';
import '@chakra-ui/utils';
import '@fortawesome/pro-solid-svg-icons';
import '@hover/icons';
import 'ramda/src/lensPath';
import 'ramda/src/set';
import '@hover/tokens-size';
import '@hover/tokens-typography';
import '@fortawesome/react-fontawesome';
import '@hover/tokens-border';
import '@hover/tokens-color';
import '@hover/tokens-device';
import '@hover/tokens-space';
import '@hover/tokens-depth';
import '@fortawesome/pro-duotone-svg-icons';
import '@hover/icons/constants';

var _excluded$3 = ["isClosable", "description"];

/**
 * Translate toast options into `Alert` props.
 *
 * @todo when we move over to `isClosable` for `Alert`, we can stop translating
 * that option
 *
 * @param options toast options
 * @returns `Alert` component props
 */
var translateOptions = function translateOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isClosable = _ref.isClosable,
      description = _ref.description,
      options = _objectWithoutProperties(_ref, _excluded$3);

  return _objectSpread2({
    showClose: isClosable,
    children: description
  }, _pick(['icon', 'status', 'title', 'variant', 'size'], options));
};

var wrap = function wrap(toast, defaultOptions) {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  var isActive = toast.isActive,
      closeAll = toast.closeAll,
      close = toast.close,
      _update = toast.update;

  var getRender = function getRender(options) {
    return function (_ref2) {
      var onClose = _ref2.onClose;
      return jsx(Alert, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
        testId: "toast-alert",
        variant: "toast"
      }, translateOptions(defaultOptions)), translateOptions(options)), defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.props), options === null || options === void 0 ? void 0 : options.props), {}, {
        onCloseClick: onClose
      }));
    };
  };

  var wrapped = Object.assign(function (options) {
    return toast(_objectSpread2(_objectSpread2({}, options), {}, {
      render: getRender(options)
    }));
  }, {
    isActive: isActive,
    closeAll: closeAll,
    close: close,
    update: function update(id, options) {
      return _update(id, _objectSpread2({
        render: getRender(options)
      }, options));
    }
  });
  return wrapped;
};

var createStandaloneToast = function createStandaloneToast(standaloneOptions) {
  var chakraToast = createStandaloneToast$1(_objectSpread2({
    theme: theme
  }, standaloneOptions));
  return wrap(chakraToast, standaloneOptions === null || standaloneOptions === void 0 ? void 0 : standaloneOptions.defaultOptions);
};

var useToast = function useToast(hookOptions) {
  var chakraToast = useToast$1(hookOptions);
  return wrap(chakraToast, hookOptions);
};

var useIsInitialRender = function useIsInitialRender() {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isInitialRender = _useState2[0],
      setIsInitialRender = _useState2[1];

  useEffect(function () {
    return setIsInitialRender(false);
  }, []);
  return isInitialRender;
};

var Styles = function Styles(_ref) {
  var _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? true : _ref$colors,
      _ref$fonts = _ref.fonts,
      fonts = _ref$fonts === void 0 ? true : _ref$fonts,
      _ref$normalize = _ref.normalize,
      normalize$1 = _ref$normalize === void 0 ? true : _ref$normalize;
  var theme = useChakraTheme();
  var themeColors = theme.colors,
      themeFonts = theme.fonts;
  !(themeColors && themeFonts) ? process.env.NODE_ENV !== "production" ? invariant(false, componentMessage('Styles', 'unable to access theme, did you forget a `<BlueprintProvider />`?')) : invariant(false) : void 0;

  var getColors = function getColors() {
    return /*#__PURE__*/css("body{background-color:", themeColors.background, ";color:", themeColors.foreground, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getColors;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  };

  var getFonts = function getFonts() {
    return /*#__PURE__*/css("body{font-family:", themeFonts.body, ";}h1,h2,h3,h4,h5,h6{font-family:", themeFonts.heading, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:getFonts;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  };

  return jsx(Global, {
    styles: /*#__PURE__*/css(colors ? getColors() : '', " ", fonts ? getFonts() : '', " ", normalize$1 ? normalize() : '', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Styles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkRpQiIsImZpbGUiOiJTdHlsZXMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgR2xvYmFsLCBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBub3JtYWxpemUgYXMgcG9saXNoZWROb3JtYWxpemUgfSBmcm9tICdwb2xpc2hlZCc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IGludmFyaWFudCBmcm9tICd0aW55LWludmFyaWFudCc7XG5cbmltcG9ydCB7IGNvbXBvbmVudE1lc3NhZ2UgfSBmcm9tICcuLi8uLi9oZWxwZXJzJztcbmltcG9ydCB7IHVzZUNoYWtyYVRoZW1lIGFzIHVzZVRoZW1lIH0gZnJvbSAnLi4vLi4vaG9va3MnO1xuXG5leHBvcnQgaW50ZXJmYWNlIFN0eWxlc1Byb3BzIHtcbiAgLyoqXG4gICAqIEFwcGx5IGBiYWNrZ3JvdW5kLWNvbG9yYCBhbmQgYGNvbG9yYCBzdHlsZXMgdG8gYGJvZHlgXG4gICAqL1xuICBjb2xvcnM/OiBib29sZWFuO1xuICAvKipcbiAgICogQXBwbHkgYGZvbnQtZmFtaWx5YCB0byBgYm9keWAgYW5kIGBoKmAgdGFnc1xuICAgKi9cbiAgZm9udHM/OiBib29sZWFuO1xuICAvKipcbiAgICogQXBwbHkgbm9ybWFsaXplLmNzc1xuICAgKi9cbiAgbm9ybWFsaXplPzogYm9vbGVhbjtcbn1cblxuY29uc3QgU3R5bGVzID0gKHsgY29sb3JzID0gdHJ1ZSwgZm9udHMgPSB0cnVlLCBub3JtYWxpemUgPSB0cnVlIH0pID0+IHtcbiAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xuICBjb25zdCB7IGNvbG9yczogdGhlbWVDb2xvcnMsIGZvbnRzOiB0aGVtZUZvbnRzIH0gPSB0aGVtZTtcblxuICBpbnZhcmlhbnQoXG4gICAgdGhlbWVDb2xvcnMgJiYgdGhlbWVGb250cyxcbiAgICBjb21wb25lbnRNZXNzYWdlKFxuICAgICAgJ1N0eWxlcycsXG4gICAgICAndW5hYmxlIHRvIGFjY2VzcyB0aGVtZSwgZGlkIHlvdSBmb3JnZXQgYSBgPEJsdWVwcmludFByb3ZpZGVyIC8+YD8nLFxuICAgICksXG4gICk7XG5cbiAgY29uc3QgZ2V0Q29sb3JzID0gKCkgPT4gY3NzYFxuICAgIGJvZHkge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHt0aGVtZUNvbG9ycy5iYWNrZ3JvdW5kfTtcbiAgICAgIGNvbG9yOiAke3RoZW1lQ29sb3JzLmZvcmVncm91bmR9O1xuICAgIH1cbiAgYDtcblxuICBjb25zdCBnZXRGb250cyA9ICgpID0+IGNzc2BcbiAgICBib2R5IHtcbiAgICAgIGZvbnQtZmFtaWx5OiAke3RoZW1lRm9udHMuYm9keX07XG4gICAgfVxuXG4gICAgaDEsXG4gICAgaDIsXG4gICAgaDMsXG4gICAgaDQsXG4gICAgaDUsXG4gICAgaDYge1xuICAgICAgZm9udC1mYW1pbHk6ICR7dGhlbWVGb250cy5oZWFkaW5nfTtcbiAgICB9XG4gIGA7XG5cbiAgcmV0dXJuIChcbiAgICA8R2xvYmFsXG4gICAgICBzdHlsZXM9e2Nzc2BcbiAgICAgICAgJHtjb2xvcnMgPyBnZXRDb2xvcnMoKSA6ICcnfVxuICAgICAgICAke2ZvbnRzID8gZ2V0Rm9udHMoKSA6ICcnfVxuICAgICAgICAke25vcm1hbGl6ZSA/IHBvbGlzaGVkTm9ybWFsaXplKCkgOiAnJ31cbiAgICAgIGB9XG4gICAgLz5cbiAgKTtcbn07XG5cbmV4cG9ydCB7IFN0eWxlcyB9O1xuIl19 */")
  });
};

var _excluded$2 = ["children", "spacing"];

var Form = function Form(_ref) {
  var children = _ref.children,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? '' : _ref$spacing,
      props = _objectWithoutProperties(_ref, _excluded$2);

  return (// @ts-ignore
    jsx(Stack, _objectSpread2(_objectSpread2({
      spacing: spacing
    }, withTestId(props)), {}, {
      as: "form",
      children: children
    }))
  );
};

var _excluded$1 = ["children"];
var Label = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return 'box' in props && props.box ? jsx(BoxWithDeprecationWarning, _objectSpread2(_objectSpread2({}, _omit(['box'], props)), {}, {
    as: "label",
    ref: ref,
    children: children
  })) : jsx(Body, _objectSpread2(_objectSpread2({}, props), {}, {
    element: "label",
    ref: ref,
    children: children
  }));
});

var _excluded = ["content", "flexDirection", "heading", "onClick", "selected", "subHeading"];

var BlockOption = function BlockOption(_ref) {
  var content = _ref.content,
      _ref$flexDirection = _ref.flexDirection,
      flexDirection = _ref$flexDirection === void 0 ? 'column' : _ref$flexDirection,
      heading = _ref.heading,
      onClick = _ref.onClick,
      selected = _ref.selected,
      subHeading = _ref.subHeading,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(selected || false),
      _useState2 = _slicedToArray(_useState, 2),
      isSelected = _useState2[0],
      setIsSelected = _useState2[1];

  var onClickBlockOption = useCallback(function () {
    setIsSelected(!isSelected);
    onClick === null || onClick === void 0 ? void 0 : onClick(!isSelected);
  }, [isSelected, onClick]);
  return jsx(TileCheckbox, _objectSpread2(_objectSpread2({
    description: content,
    isChecked: isSelected,
    onChange: onClickBlockOption,
    variant: flexDirection === 'row' ? 'horizontal' : 'vertical'
  }, props), {}, {
    children: jsxs(HStack, {
      justifyContent: "space-between",
      children: [jsx(Body, {
        "aria-level": 5,
        as: "span",
        fontWeight: "heading",
        role: "heading",
        children: heading
      }), flexDirection === 'column' && subHeading && jsx(Body, {
        "aria-level": 6,
        as: "span",
        color: "neutral.600",
        fontWeight: "heading",
        role: "heading",
        children: subHeading
      })]
    })
  }));
};

/**
 * Apply custom theme overrides to the default Blueprint theme
 *
 * @param overrides theme additions and/or customizations
 * @returns
 */
var applyThemeOverrides = function applyThemeOverrides(overrides) {
  return extendTheme(overrides, theme);
};

export { BlockOption, Form, Label, Styles, applyThemeOverrides, createStandaloneToast, useIsInitialRender, useToast };
